import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-383390e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "centre main" }
const _hoisted_2 = { class: "progress" }
const _hoisted_3 = {
  key: 0,
  class: "guesses"
}
const _hoisted_4 = {
  class: "guess-blocks",
  "aria-hidden": "true"
}
const _hoisted_5 = {
  key: 0,
  class: "result-text"
}
const _hoisted_6 = {
  key: 1,
  class: "result-text"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("You got didn't get this ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Mario", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" track. Better luck next time!")
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "buttons" }
const _hoisted_12 = {
  key: 0,
  class: "centre volume-note"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Turn up the volume and tap to start the track!", -1))
const _hoisted_14 = { class: "progress-bar-container" }
const _hoisted_15 = { class: "centre" }
const _hoisted_16 = { class: "centre player" }
const _hoisted_17 = { class: "current-time" }
const _hoisted_18 = ["aria-label", "title"]
const _hoisted_19 = {
  key: 1,
  class: "sound-animation",
  "aria-hidden": "true"
}
const _hoisted_20 = { class: "total-time" }
const _hoisted_21 = { class: "centre search" }
const _hoisted_22 = {
  class: "clear",
  "aria-label": "Clear",
  title: "Clear"
}
const _hoisted_23 = {
  key: 1,
  class: "centre buttons"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Skip ")
const _hoisted_25 = {
  key: 0,
  class: "lc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, "Track " + _toDisplayString(_ctx.currentRound + 1) + " / " + _toDisplayString(_ctx.totalRounds), 1),
      (!_ctx.roundFinished)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guessList, (guess, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: i,
                class: _normalizeClass(`guess-${guess.class}`)
              }, [
                (guess.icon)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: ['far',guess.icon]
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(guess.answer ?? '\xa0'), 1)
              ], 2))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", {
              class: _normalizeClass(["track-title", {correct: _ctx.playerCorrect>0}])
            }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.currentTrack.answer), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.currentGame.title), 1)
            ], 2),
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guessList, (guess, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: _normalizeClass(`guess-${guess.class}`)
                }, null, 2))
              }), 128))
            ]),
            (_ctx.playerCorrect)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "You got this track in " + _toDisplayString(_ctx.playerCorrectTime) + " " + _toDisplayString(_ctx.playerCorrectTime === 1 ? 'second' : 'seconds') + "!", 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, _hoisted_10)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.nextTrack && _ctx.nextTrack(...args)))
              }, "Next"),
              (_ctx.currentRound > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previousTrack && _ctx.previousTrack(...args)))
                  }, "Back"))
                : _createCommentVNode("", true)
            ])
          ], 64))
    ]),
    (_ctx.firstRound)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_font_awesome_icon, { icon: ['far','chevron-down'] })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          class: _normalizeClass(["progress-bar", {bg: _ctx.roundFinished}])
        }, [
          _createElementVNode("div", {
            class: "progress-position",
            style: _normalizeStyle({width:_ctx.endTime ? `${(_ctx.audioCurrentPosition/_ctx.endTime)*100}%`: '0'})
          }, null, 4),
          (!_ctx.roundFinished)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.secondSteps, (step, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["progress-step", {available: _ctx.guessList[i].class !== 'none'}]),
                  style: _normalizeStyle({'flex-grow': step})
                }, null, 6))
              }), 256))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.currentTimeDisplay), 1),
      _createElementVNode("button", {
        class: "play",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args))),
        "aria-label": _ctx.audioPlaying ? 'Stop playing' : 'Play',
        title: _ctx.audioPlaying ? 'Stop playing' : 'Play'
      }, [
        (!_ctx.audioPlaying)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              icon: ['far','play']
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_19))
      ], 8, _hoisted_18),
      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.endTimeDisplay), 1)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_21, [
      _createVNode(_component_font_awesome_icon, {
        class: "icon",
        icon: ['far','magnifying-glass']
      }),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.musicInput) = $event)),
        ref: "formField",
        id: "autocomplete",
        onKeydown: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"])),
        onOpen: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.dropdownOpened && _ctx.dropdownOpened(...args))),
        onClose: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.dropdownClosed && _ctx.dropdownClosed(...args)))
      }, null, 544), [
        [_vModelText, _ctx.musicInput]
      ]),
      _createElementVNode("button", _hoisted_22, [
        _createVNode(_component_font_awesome_icon, { icon: ['far','xmark'] })
      ])
    ], 512), [
      [_vShow, !_ctx.roundFinished]
    ]),
    (!_ctx.roundFinished)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, "Submit"),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.skip && _ctx.skip(...args)))
          }, [
            _hoisted_24,
            (_ctx.nextAttemptTime)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, "(+" + _toDisplayString(_ctx.nextAttemptTime) + "s)", 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}